import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import FormField from '../FormField';
import { useTranslation } from 'react-i18next';

const InternationalBank = React.forwardRef(
    (
        {
            pspId,
            token,
            lyriaUrl,
            hidePayButton = false,
            onPaymentResult,
        },
        ref
    ) => {
        const { t } = useTranslation();
        const formRef = React.useRef(null);
        const [errors, setErrors] = React.useState({});
        
        const submitForm = (event) => {
            event.preventDefault();
            event.stopPropagation();
            const formData = new FormData(event.currentTarget);
            const data = {};
            for (let entry of formData.entries()) {
                data[entry[0]] = entry[1];
            }

            axios({
                method: 'post',
                url: lyriaUrl + '/internationalbank/save',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: {
                    data: data,
                    request_token: token,
                    psp: pspId,
                }
            }).then(function({ data }) {
                handleSuccess();
            }).catch(function(error) {
                if (error.response.status === 400) {
                    handleError(error.response.data);
                } else {
                    console.error(error.response);
                }
            });
        };

        React.useImperativeHandle(ref, () => ({
            pay() {
                return formRef.current.click();
            }
        }));

        const handleSuccess = () => {
            onPaymentResult({ success: true });
        };

        const handleError = response => {
            setErrors(response.data);
            onPaymentResult({ success: false, data: response });
        };

        return (
            <div className="wz-lyriapay-form">
                <form noValidate onSubmit={submitForm}>
                    <div className="wz-lyriapay-flexcontainer">
                        <div className="wz-lyriapay-groupformblock">
                            <FormField 
                                name="first_name"
                                label="international_bank_firstName"
                                errors={errors.first_name}
                            />
                            <FormField 
                                name="last_name"
                                label="international_bank_lastName"
                                errors={errors.last_name}
                            />
                        </div>
                        <FormField 
                            name="bank_name"
                            label="international_bank_bankName"
                            errors={errors.bank_name}
                        />
                        <FormField 
                            name="account_number"
                            label="international_bank_accountNumber"
                            errors={errors.account_number}
                        />
                        <FormField 
                            name="swift_code"
                            label="international_bank_swiftCode"
                            errors={errors.swift_code}
                        />
                        <FormField 
                            name="address"
                            label="international_bank_address"
                            errors={errors.address}
                        />
                        <div className="wz-lyriapay-groupformblock">
                            <FormField 
                                name="city"
                                label="international_bank_city"
                                errors={errors.city}
                            />
                            <FormField 
                                name="zipcode"
                                label="international_bank_zipcode"
                                errors={errors.zipcode}
                            />
                        </div>
                        <div className="wz-lyriapay-groupformblock">
                            <FormField 
                                name="region"
                                label="international_bank_region"
                                errors={errors.region}
                            />
                            <FormField 
                                name="country"
                                label="international_bank_country"
                                errors={errors.country}
                            />
                        </div>
                    </div>
                    <div>
                        <button
                            className="wz-lyriapay-formsubmit"
                            type="submit"
                            ref={formRef}
                            style={hidePayButton ? {
                                /*
                                note: we hide the button instead of removing it from the DOM
                                because the browser will trigger the buttonʼs onClick if we press Enter in any of the form input
                                it work if the button is hidden, it doesnʼt work if there is no button
                                */
                                display: 'none'
                            } : {}}>
                            {t('payButton')}
                        </button>
                    </div>
                </form>
            </div>
        );
    }
);

InternationalBank.propTypes = {
    pspId: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    lyriaUrl: PropTypes.string.isRequired,
    hidePayButton: PropTypes.bool,
    onPaymentResult: PropTypes.func.isRequired
};

export default InternationalBank;